module.exports = __webpack_public_path__ + "cb017457d3cc579a642e0edd25d258cc.MP3";